import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface AgentAssignment {
  id: number;
  agentName: string;
  assignedPorts: number;
  ports: string[];
}

@Component({
  selector: 'app-port-assignments-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './port-assignments-tab.html',
  styleUrl: './port-assignments-tab.css'
})
export class PortAssignmentsTabComponent implements OnInit {
  // Sample agent data
  agents: AgentAssignment[] = [
    { id: 1, agentName: 'Global Freight Ltd.', assignedPorts: 0, ports: [] },
    { id: 2, agentName: 'John Smith', assignedPorts: 0, ports: [] },
    { id: 3, agentName: 'Maria Garcia', assignedPorts: 0, ports: [] },
    { id: 4, agentName: 'Maritime Solutions', assignedPorts: 0, ports: [] },
    { id: 5, agentName: 'NCL Freight Shanghai Ltd', assignedPorts: 0, ports: [] },
    { id: 6, agentName: 'Nehro Abraham Ranay', assignedPorts: 0, ports: [] },
    { id: 7, agentName: 'Ocean Express', assignedPorts: 0, ports: [] },
    { id: 8, agentName: 'Pacific Shipping Co.', assignedPorts: 0, ports: [] }
  ];

  showAssignPortModal = false;
  selectedAgent: AgentAssignment | null = null;

  constructor() {}

  ngOnInit(): void {
    console.log('[PortAssignmentsTab] Component initialized');
  }

  openAssignPortModal(agent: AgentAssignment): void {
    this.selectedAgent = agent;
    this.showAssignPortModal = true;
  }

  closeAssignPortModal(): void {
    this.showAssignPortModal = false;
    this.selectedAgent = null;
  }

  assignFirstPort(agent: AgentAssignment): void {
    this.openAssignPortModal(agent);
  }
}
